import { useMutation } from '@tanstack/react-query';
import { GET, GET_CUSTOMER_LINE } from '../../services';
import { navigateTo } from '../../utils/navigation';
import { ROUTES_PATH } from '../../resources/routes-name';
import { openAlert } from '../../components/alert/hooks';

export const useGetCustomer = () => {
  return useMutation({
    mutationFn: async ({ userId }) => {
      const response = await GET(GET_CUSTOMER_LINE(userId));
      return response;
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
      navigateTo({ pathname: ROUTES_PATH.ROUTE_LOGIN_DEALER.PATH });
    },
  });
};
